import React from 'react';
import { Button, Col, Container, Form, Row } from "react-bootstrap";

const AddressTab = () => {
    return (
        <div className="address_tab_screen">
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    House No
                                </Form.Label>
                                <Form.Control type="text" placeholder="Jitender Singh" required />
                            </Form.Group>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Area<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="text" placeholder="20" required />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Pin Code<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option selected>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            District<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option selected>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            City<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="text" placeholder="20" required />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    State<span>*</span>
                                </Form.Label>
                                <Form.Select required>
                                    <option selected>NA</option>
                                    <option value="1">NA</option>
                                    <option value="2">NA</option>
                                </Form.Select>
                            </Form.Group>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Contact Number<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="number" placeholder="+91-7987987987" required />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Alternate Number
                                        </Form.Label>
                                        <Form.Control type="number" placeholder="+91-7987987987" required />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Email
                                </Form.Label>
                                <Form.Control type="text" placeholder="harjinder12@gmail.com" required />
                            </Form.Group>
                            <div className="btn_area">
                                <Button className="cancelBtn" type="button" >Cancel</Button>
                                <Button className="submitBtn" type="submit">Next</Button>
                            </div>

                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default AddressTab;